<template>
  <v-app>
    <v-main>

      <router-view v-slot="{ Component }">
        <div>
          <GlobalHeader/>
          <transition name="fade">
            <component :is="Component"/>
          </transition>
        <GlobalFooter v-if="shouldShowFooter" />


        </div>
      </router-view>
      <v-fab
          :app="true"
          extended
          color="rgb(27 132 255 / var(--tw-bg-opacity, 1))"
          location="right bottom"
          style="z-index: 15"
          class="text-white"
          to="/inquiry"
      >
        <span class="text-white">{{$t('inquiry')}}</span>
     </v-fab>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import GlobalHeader from "@/components/GlobalHeader/GlobalHeader.vue";
import GlobalFooter from "@/components/GlobalFooter/GlobalFooter.vue";
import {useRoute, useRouter} from "vue-router";
import {useUserStore} from "@/stores/userStore";
import {computed, onMounted, watch} from "vue";
import { useAuth0 } from '@auth0/auth0-vue';
import { applyCommonInterceptors, apiClient } from '@/services/client';

const userStore = useUserStore();
const route = useRoute();

const hideFooterRoutes = ['login', 'register', 'forgot-password', 'reset-password'];

const shouldShowFooter = computed(() => {
  return !hideFooterRoutes.includes(route.name);
});


onMounted(() => {
  const { getAccessTokenSilently } = useAuth0();

  applyCommonInterceptors(apiClient, async () => {
    try {
      const token = await getAccessTokenSilently();
      return token;
    } catch (e) {
      return null;
    }
  });
});

</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.1s ease-out;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>